import { createSlice } from "@reduxjs/toolkit";
import {
  addAmenity,
  deleteAmenity,
  getAllAmenities,
  getAmenityDetails,
  getAmenityList,
  updateAmenity,
  updateAmenityStatus,
} from "store/actions/amenitySlice";

const initialState = {
  isLoading: false,
  loading: false,
  perPage: 10,
  totalCount: null,
  totalPages: null,
  currentPage: null,
  amenities: [],
  amenitiesList: [],
  amenityDetails: {},
  gettingDetails: false,
};

const branchSlice = createSlice({
  name: "amenities",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(getAllAmenities.pending, (state) => {
        state.loading = true;
      })
      .addCase(getAllAmenities.fulfilled, (state, action) => {
        state.loading = false;
        const { success } = action.payload || {};
        if (success) {
          const { data, totalCount, totalPages, currentPage } =
            action.payload || {};

          state.amenities = data;
          state.totalCount = totalCount || null;
          state.totalPages = totalPages || null;
          state.currentPage = currentPage || null;
        }
      })
      .addCase(getAllAmenities.rejected, (state, action) => {
        state.loading = false;
      });

    builder
      .addCase(getAmenityList.pending, (state) => {})
      .addCase(getAmenityList.fulfilled, (state, action) => {
        const { success, data } = action.payload || {};
        if (success) {
          state.amenitiesList = data;
        }
      })
      .addCase(getAmenityList.rejected, (state, action) => {});

    builder
      .addCase(updateAmenityStatus.pending, (state) => {
        state.isLoading = true;
      })
      .addCase(updateAmenityStatus.fulfilled, (state, action) => {
        state.isLoading = false;
        const { success } = action.payload || {};
        if (success) {
          const { id, status } = action.meta.arg;
          state.amenities = state?.amenities?.map((item) =>
            item._id === id ? { ...item, status: status } : item
          );
        }
      })
      .addCase(updateAmenityStatus.rejected, (state, action) => {
        state.isLoading = false;
      });

    builder
      .addCase(addAmenity.pending, (state) => {
        state.isLoading = true;
      })
      .addCase(addAmenity.fulfilled, (state, action) => {
        state.isLoading = false;
        const { success, data } = action.payload || {};
        if (success) {
          state.amenities.push(data);
        }
      })
      .addCase(addAmenity.rejected, (state, action) => {
        state.isLoading = false;
      });

    builder
      .addCase(updateAmenity.pending, (state) => {
        state.isLoading = true;
      })
      .addCase(updateAmenity.fulfilled, (state, action) => {
        state.isLoading = false;
        const { success, data } = action.payload || {};
        if (success) {
          state.amenities = state?.amenities?.map((item) =>
            item._id === data._id ? data : item
          );
        }
      })
      .addCase(updateAmenity.rejected, (state, action) => {
        state.isLoading = false;
      });

    builder
      .addCase(getAmenityDetails.pending, (state) => {
        state.gettingDetails = true;
      })
      .addCase(getAmenityDetails.fulfilled, (state, action) => {
        state.gettingDetails = false;
        const { success, data } = action.payload || {};
        if (success) {
          state.amenityDetails = data;
        }
      })
      .addCase(getAmenityDetails.rejected, (state, action) => {
        state.gettingDetails = false;
      });

    builder
      .addCase(deleteAmenity.pending, (state) => {
        state.isLoading = true;
      })
      .addCase(deleteAmenity.fulfilled, (state, action) => {
        state.isLoading = false;
        const { success } = action.payload || {};
        if (success) {
          const { id } = action.meta.arg;
          state.amenities = state.amenities.filter((item) => item._id !== id);
          if (state.totalCount !== null) {
            state.totalCount -= 1;
          }
        }
      })
      .addCase(deleteAmenity.rejected, (state, action) => {
        state.isLoading = false;
      });
  },
});

export default branchSlice.reducer;
